<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Admin: Link to Conversation</v-card-title>

        <v-card-text>

            <m-edit-text
                :value="front_link.endpoint"
                label="Endpoint"
                read_only
            />

            <m-edit-text
                :value="front_link.employee_id"
                label="Employee Id"
                read_only
            />

            <m-code-block
                :click_anywhere_to_copy="false"
            >
               {{front_link.url}}
            </m-code-block>

            {{front_link}}
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,

            front_link: {},
        }
    },

    methods: {

        showDialog(endpoint, conversation_id)
        {
            this.$rc.showSpinner();
            
            this.$rc.adminFrontEndLinkToConversation(
                endpoint,
                conversation_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.front_link = data;

                    this.dialog = true;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
            
        },

        onOk()
        {
            this.dialog = false;
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>